import _ from 'lodash'

export default {
  methods: {
    formatDecimalNumber(value, numberOfDecimalPlaces, thousandSeparator, decimalSeparator) {
      const tChar = thousandSeparator || '.'
      const dChar = decimalSeparator || ','

      const parts = String(_.round(Number(value), numberOfDecimalPlaces).toFixed(numberOfDecimalPlaces)).split('.')
      return String(parts[0]).replace(/\B(?=(\d{3})+(?!\d))/g, tChar) + dChar + parts[1]
    },

    formatIntegerNumber(value, thousandSeparator) {
      const tChar = thousandSeparator || '.'
      return String(value).replace(/\B(?=(\d{3})+(?!\d))/g, tChar)
    },
  },
}
